import { Injectable, OnDestroy } from "@angular/core";
import { AuthService } from "@mydocma/auth";
import { UntilDestroy } from "@ngneat/until-destroy";
import { BehaviorSubject, filter } from "rxjs";

export enum CoPermissionArea {
    Plans = "plans",
    BimModels = "bimModels",
    BimSections = "bimSections",
    PlanAssignments = "planAssignments",
    Missions = "missions",
    Structure = "structure"
}

export enum CoPermissionType {
    Visible = "visible",
    Create = "create",
    Update = "update",
    Delete = "delete",
    ForceDelete = "forceDelete"
}
@UntilDestroy()
@Injectable({providedIn: 'root'})
export class CoPermissionsService implements OnDestroy {

    private projectConfigPermissionsSubject = new BehaviorSubject(null);
    public projectConfigPermissions$ = this.projectConfigPermissionsSubject.asObservable();

    private schemaGlobalConfigurationSubject = new BehaviorSubject<any>(null);
    public schemaGlobalConfiguration$ = this.schemaGlobalConfigurationSubject.asObservable();

    private currentUserSubject = new BehaviorSubject<string>(null);
    public currentUser$ = this.currentUserSubject.asObservable();

    // TODO: CHECK ID AND NOT NAME -> API needs to be expanded
    public currentUser: string;

    public get projectPermissions() {
        return this.projectConfigPermissionsSubject.value;
    }

    // FOR TESTING / DEBUG
    private ignorePermissions = false;
    private enforceReadonly = false;

    constructor(private readonly authService: AuthService) {

        this.authService.userPermissions.subscribe((p: any) => {
            this.projectConfigPermissionsSubject.next(p?.projectConfig?.area)
            this.schemaGlobalConfigurationSubject.next(p?.schema?.globalConfiguration);
        });

        this.authService.user.pipe(filter(Boolean)).subscribe(user => {
            this.currentUser = user.name; //TODO: Use only subject and adopt other places to call the observable
            this.currentUserSubject.next(user.name);
        })
    }

    public hasProjectPermission(area: CoPermissionArea, permissionType: CoPermissionType): boolean {
        if(this.ignorePermissions) return true;
        if(this.enforceReadonly) return false;

        if(area == CoPermissionArea.PlanAssignments) {
            return !!(this.projectConfigPermissionsSubject?.value?.bimSections?.[area]?.[permissionType]);
        }

        return !!(this.projectConfigPermissionsSubject?.value?.[area]?.[permissionType]);
    }

    public hasOwnStaffPermission(permissionType: CoPermissionType): boolean {
        if(this.ignorePermissions) return true;
        if(this.enforceReadonly) return false;

        const globalConfiguration = this.schemaGlobalConfigurationSubject?.value;
        return !!(globalConfiguration?.ownStaff?.[permissionType]);
    }

    public isGlobalConfigurationEnabled(): boolean {
        if(this.ignorePermissions) return true;
        if(this.enforceReadonly) return false;

        const globalConfiguration = this.schemaGlobalConfigurationSubject?.value;
        return !!(globalConfiguration?.enable);
    }

    ngOnDestroy(): void {}


}
